// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Showcase.css - 视频模板展示组件样式 */

/* ===== Showcase区域 ===== */
.showcase {
  padding: 50px 5% 80px;
  background: linear-gradient(to bottom, #050810, #0a0f1d);
}

.showcase h3 {
  margin-bottom: 35px;
  font-family: 'Orbitron';
  font-size: 1.3rem;
  color: #fff;
  letter-spacing: 2px;
}

/* ===== 卡片网格 ===== */
.grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 20px;
  align-items: stretch;
}

/* ===== 视频卡片 ===== */
.card {
  height: 280px;
  background: #131a2f;
  border-radius: 18px;
  overflow: hidden;
  position: relative;
  border: 1px solid rgba(255, 255, 255, 0.05);
  transition: 0.4s;
}

.card:hover {
  transform: translateY(-10px);
  border-color: var(--primary);
  box-shadow:
    0 20px 40px rgba(0, 0, 0, 0.6),
    0 0 25px rgba(0, 229, 255, 0.3);
}

.card img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  opacity: 0.75;
  transition: 0.5s;
}

.card:hover img {
  opacity: 1;
  transform: scale(1.05);
}

/* ===== 卡片信息 ===== */
.card-info {
  position: absolute;
  bottom: 0;
  width: 100%;
  padding: 20px;
  background: linear-gradient(transparent, rgba(5, 8, 16, 0.95));
}

.card-info h4 {
  font-size: 0.95rem;
  color: #fff;
  margin-bottom: 4px;
  font-family: 'Exo 2', sans-serif;
  font-weight: 600;
}

.card-info p {
  font-size: 0.75rem;
  color: var(--primary);
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .grid {
    grid-template-columns: repeat(4, 1fr);
  }
}

@media (max-width: 900px) {
  .grid {
    grid-template-columns: repeat(3, 1fr);
  }

  .showcase h3 {
    font-size: 1.1rem;
  }
}

@media (max-width: 600px) {
  .grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 15px;
  }

  .card {
    height: 220px;
  }

  .showcase {
    padding: 40px 3% 60px;
  }

  .showcase h3 {
    font-size: 1rem;
    margin-bottom: 25px;
  }

  .card-info {
    padding: 15px;
  }

  .card-info h4 {
    font-size: 0.85rem;
  }

  .card-info p {
    font-size: 0.7rem;
  }
}

@media (max-width: 400px) {
  .grid {
    grid-template-columns: 1fr;
    gap: 12px;
  }

  .card {
    height: 200px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Showcase.css"],"names":[],"mappings":"AAAA,8BAA8B;;AAE9B,2BAA2B;AAC3B;EACE,qBAAqB;EACrB,wDAAwD;AAC1D;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,WAAW;EACX,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,oBAAoB;AACtB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,2CAA2C;EAC3C,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,4BAA4B;EAC5B;;mCAEiC;AACnC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,sBAAsB;AACxB;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,aAAa;EACb,8DAA8D;AAChE;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA,UAAU;AACV;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,qCAAqC;IACrC,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":["/* Showcase.css - 视频模板展示组件样式 */\n\n/* ===== Showcase区域 ===== */\n.showcase {\n  padding: 50px 5% 80px;\n  background: linear-gradient(to bottom, #050810, #0a0f1d);\n}\n\n.showcase h3 {\n  margin-bottom: 35px;\n  font-family: 'Orbitron';\n  font-size: 1.3rem;\n  color: #fff;\n  letter-spacing: 2px;\n}\n\n/* ===== 卡片网格 ===== */\n.grid {\n  display: grid;\n  grid-template-columns: repeat(5, 1fr);\n  gap: 20px;\n  align-items: stretch;\n}\n\n/* ===== 视频卡片 ===== */\n.card {\n  height: 280px;\n  background: #131a2f;\n  border-radius: 18px;\n  overflow: hidden;\n  position: relative;\n  border: 1px solid rgba(255, 255, 255, 0.05);\n  transition: 0.4s;\n}\n\n.card:hover {\n  transform: translateY(-10px);\n  border-color: var(--primary);\n  box-shadow:\n    0 20px 40px rgba(0, 0, 0, 0.6),\n    0 0 25px rgba(0, 229, 255, 0.3);\n}\n\n.card img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  opacity: 0.75;\n  transition: 0.5s;\n}\n\n.card:hover img {\n  opacity: 1;\n  transform: scale(1.05);\n}\n\n/* ===== 卡片信息 ===== */\n.card-info {\n  position: absolute;\n  bottom: 0;\n  width: 100%;\n  padding: 20px;\n  background: linear-gradient(transparent, rgba(5, 8, 16, 0.95));\n}\n\n.card-info h4 {\n  font-size: 0.95rem;\n  color: #fff;\n  margin-bottom: 4px;\n  font-family: 'Exo 2', sans-serif;\n  font-weight: 600;\n}\n\n.card-info p {\n  font-size: 0.75rem;\n  color: var(--primary);\n}\n\n/* 响应式设计 */\n@media (max-width: 1200px) {\n  .grid {\n    grid-template-columns: repeat(4, 1fr);\n  }\n}\n\n@media (max-width: 900px) {\n  .grid {\n    grid-template-columns: repeat(3, 1fr);\n  }\n\n  .showcase h3 {\n    font-size: 1.1rem;\n  }\n}\n\n@media (max-width: 600px) {\n  .grid {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 15px;\n  }\n\n  .card {\n    height: 220px;\n  }\n\n  .showcase {\n    padding: 40px 3% 60px;\n  }\n\n  .showcase h3 {\n    font-size: 1rem;\n    margin-bottom: 25px;\n  }\n\n  .card-info {\n    padding: 15px;\n  }\n\n  .card-info h4 {\n    font-size: 0.85rem;\n  }\n\n  .card-info p {\n    font-size: 0.7rem;\n  }\n}\n\n@media (max-width: 400px) {\n  .grid {\n    grid-template-columns: 1fr;\n    gap: 12px;\n  }\n\n  .card {\n    height: 200px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
